import { Box } from "@mui/material";

export function Background({ background }) {
  return (
    <Box
      component="img"
      src={background}
      alt=""
      fetchPriority="high"
      sx={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        objectPosition: { xs: "50% 50%", md: "center" },
        zIndex: 0,
      }}
    />
  );
}
